import { useEffect, useState } from 'react'

type Input = {
  scrollContainer: HTMLElement | undefined
  threshold?: number
}

export const useScrollBoundary = ({ scrollContainer, threshold = 0 }: Input) => {
  const [isPastBoundary, setIsPastBoundary] = useState(false)

  useEffect(() => {
    if (!scrollContainer) return

    const handleScroll = () => {
      setIsPastBoundary(scrollContainer.scrollTop > threshold)
    }

    scrollContainer.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll)
    }
  }, [scrollContainer, threshold])

  return isPastBoundary
}
